import Popup from "./popup";

export default {
  install: function(Vue) {
    Vue.component("Popup", Popup);
  }
};
